RivalIQ.module('props', function (module, App, Backbone, Marionette, $, _) {

    'use strict';

    /*
     * Returns the company name for the company specified in the companyId prop
     */
    module.companyName = function (props) {
        return RivalIQ.state.landscape.get('companies').get(props.companyId).get('name');
    };
});
